<script>
  import Icon from "@iconify/svelte";
  import { locales, t } from "../lib/i18n.js";

  let { locale = $bindable("en"), onchange = () => {} } = $props();

  const flags = {
    en: "circle-flags:us",
    fr: "circle-flags:fr",
    es: "circle-flags:es",
    pt: "circle-flags:pt",
  };

  const labels = {
    en: "English",
    fr: "Français",
    es: "Español",
    pt: "Português",
  };

  let open = $state(false);

  function select(code) {
    locale = code;
    onchange(code);
    open = false;
  }
</script>

<div class="relative inline-flex" role="group">
  <button
    type="button"
    class="inline-flex h-10 items-center justify-center gap-1.5 rounded-xl border border-white/10 bg-white/[0.035] px-2.5 text-sm text-zinc-200 transition-all hover:bg-white/[0.06] focus:outline-none focus:ring-2 focus:ring-sky-400/20"
    onclick={() => (open = !open)}
    onblur={() => setTimeout(() => (open = false), 150)}
    aria-haspopup="listbox"
    aria-expanded={open}
    aria-label={t(locale, "lang_label")}
    title={t(locale, "lang_label")}
  >
    <Icon icon={flags[locale] || flags.en} class="h-5 w-5 shrink-0 rounded-full" />
    <span class="hidden text-xs uppercase text-zinc-400 sm:inline">{locale}</span>
    <Icon icon="mdi:chevron-down" class="h-4 w-4 text-zinc-500 transition-transform {open ? 'rotate-180' : ''}" />
  </button>

  {#if open}
    <ul
      class="absolute right-0 top-full z-[70] mt-1.5 min-w-[150px] overflow-hidden rounded-xl border border-white/10 bg-zinc-950 py-1 shadow-xl shadow-black/40"
      role="listbox"
      aria-label={t(locale, "lang_label")}
    >
      {#each locales as code}
        <li role="option" aria-selected={locale === code}>
          <button
            type="button"
            class="flex w-full items-center gap-2 px-3 py-2 text-left text-sm transition-colors {locale === code ? 'bg-white/[0.08] text-white' : 'text-zinc-300 hover:bg-white/[0.05] hover:text-white'}"
            onclick={() => select(code)}
          >
            <Icon icon={flags[code] || flags.en} class="h-5 w-5 shrink-0 rounded-full" />
            <span>{labels[code] || code.toUpperCase()}</span>
          </button>
        </li>
      {/each}
    </ul>
  {/if}
</div>
